module.exports = __webpack_public_path__ + "static/mazda-45ff2f8ab1cdbaa3e2a6d26bc3047ef4.png";